import React,{ useEffect, useState } from 'react'
import * as User from '@/common/api/user'
import cookie from 'react-cookies'
import config from "@/config";
function singleLogin(props) {
    const layout = {
        wrapperCol: { span: 24 }
    };
    const tailLayout = {
        wrapperCol: { span: 24 }
    };
    //获取地址栏参数，key:参数名称
    //获取地址栏参数
    function getUrlParams() {
        let url = window.location.href; //获取url中"?"符后的字串
        let paramsObj = new Object();
        if (url.indexOf("?") != -1) {
            let str = url.split("?")[1];
            str = str.split("&");
            for (let i = 0; i < str.length; i++) {
                paramsObj[str[i].split("=")[0]] = decodeURI(str[i].split("=")[1]);
            }
        }
        return paramsObj;
    }
    function getUserInfo () {
        // 从地址栏中获取token
        const token = getUrlParams().token
        if(!token || token == ''){
            React.$message.error('token为空')
        }else{
            cookie.save('user_token', token)
            User.getUserInfo().then(res => {
                if (res.code === 0) {
                    React.$message.success('登录成功')
                    if (config.pubshAdd === 'tj') {
                        User.getUserInfo().then(res => {
                            sessionStorage.setItem('FY_SCMP_USER_ID',res.data.id)
                            sessionStorage.setItem('FY_SCMP_USER_DEPT_ID',res.data.deptList && res.data.deptList.length > 0 ? res.data.deptList[0].id : res.data.deptId)
                            res.data.menuList.some(item => {
                                if (item.menuCode === 'home') {
                                    props.history.push('/home')
                                    return true
                                } else {
                                    props.history.push('/home1')
                                }
                            })
                        })
                    } else {
                        props.history.push('/home1')
                    }
                }
            })
        }
    }
    useEffect(() =>{
        getUserInfo()
    }, [])
   return (
       <div className="login"
           style={{ minHeight: '100vh' }}
       >
       </div>
   )
}
export default singleLogin
